module.exports = __webpack_public_path__ + "img/hero-presents-collage-postcard.1bca872c.png";